<template>
    <div>
        <!--General Top Bar -->
        <!-- <general-top-bar :title="$t('pages.reports')" class="mar-bt-0"></general-top-bar> -->
        <!--End General Top Bar -->
        <div id="outer-container">
            <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
                <div class="card-content">
                    <div class="clearfix row pad-lf-10 pad-rg-10">
                        <a
                          class="btn btn-fill btn-primary"
                          :class="{ active: isWalletReportActive }"
                          @click="openWalletReport"
                        >{{$t('dispath.walletReport')}}</a>
                        <a
                          class="btn btn-fill btn-primary"
                          :class="{ active: isActiveProgramActive }"
                          @click="openActiveProgram"
                        >{{$t('dispath.programReport')}}</a>
                        <a
                          class="btn btn-fill btn-primary"
                          :class="{ active: isActiveActivityActive }"
                          @click="openActivityProgram"
                        >{{$t('dispath.activityReport')}}</a>
                        <a
                          class="btn btn-fill btn-primary"
                          :class="{ active: isMapReportActive }"
                          @click="openMapReport"
                        >{{$t('dispath.mapReport')}}</a>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isWalletReportActive">
            <div class="filter row">
                <div class="col-md-12">
                    <div class="pull-left mar-rt-10">
                        <span class="pad-rg-5">{{$t('dispath.selectDriver')}}</span>
                        <v-select
                            multiple
                            style="display: inline-block; max-width: 600px;"
                            :options="drivers"
                            label="name"
                            v-model="selectedDriversWallet"
                        >
                        </v-select>
                    </div>
                    <div class="datetime-picker pull-left">
                        <!-- Selectați data și ora de început -->
                        <el-date-picker
                        v-model="fromDateTimeWallet"
                        type="datetime"
                        placeholder="Select From Date & Time"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                        to
                        <!-- Selectați data și ora de sfârșit -->
                        <el-date-picker
                        v-model="toDateTimeWallet"
                        type="datetime"
                        placeholder="Select To Date & Time"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                    </div>
                    <div class="pull-left search-button-reports">
                        <div
                            :title="$t('reports.search')"
                            class="btn btn-icon btn-info btn-search"
                            @click="sendEncashmentReport"
                        >
                            <i class="ti-search"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mar-to-15">
                <div class="card-content">
                    <div class="data-table">
                        <el-table :data="walletData">
                            <el-table-column prop="driverId" :label="$t('dispath.driverID')"></el-table-column>
                            <el-table-column prop="driverName" :label="$t('dispath.driverName')"></el-table-column>
                            <el-table-column prop="value" :label="$t('dispath.value')"></el-table-column>
                            <el-table-column :label="$t('dispath.from')">
                                <template slot-scope="scope">
                                    <!-- Check if adminName exists, otherwise display orderId -->
                                    <span v-if="scope.row.adminName && scope.row.adminName !== 'N/A'">{{ scope.row.adminName }}</span>
                                    <span v-else>{{ scope.row.orderId || 'N/A' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="createdAt" label="Date">
                            <template slot-scope="scope">
                                {{ formatDate(scope.row.createdAt) }}
                            </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isActiveProgramActive">
          <div class="filter row">
                <div class="col-md-12">
                    <div class="pull-left mar-rt-10">
                        <span class="pad-rg-5">{{$t('dispath.selectDriver')}}</span>
                        <v-select
                            multiple
                            style="display: inline-block; max-width: 600px;"
                            :options="drivers"
                            label="name"
                            v-model="selectedDriversProgram"
                        >
                        </v-select>
                    </div>
                    <div class="datetime-picker pull-left">
                        <!-- Selectați data și ora de început -->
                        <el-date-picker
                        v-model="fromDateTimeProgram"
                        type="datetime"
                        placeholder="Select From Date & Time"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                        to
                        <!-- Selectați data și ora de sfârșit -->
                        <el-date-picker
                        v-model="toDateTimeProgram"
                        type="datetime"
                        placeholder="Select To Date & Time"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                    </div>
                    <div class="pull-left search-button-reports">
                        <div
                            :title="$t('reports.search')"
                            class="btn btn-icon btn-info btn-search"
                            @click="sendProgramReport"
                        >
                            <i class="ti-search"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mar-to-15">
                <div class="card-content">
                    <div class="data-table">
                        <el-table :data="programData">
                            <el-table-column prop="driver_id" :label="$t('dispath.driverID')"></el-table-column>
                            <el-table-column :label="$t('dispath.driverName')">
                                <template slot-scope="scope">
                                    {{ scope.row.driver.firstname }} {{ scope.row.driver.lastname }}
                                </template>
                            </el-table-column>
                            <el-table-column label="Status">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.status">START</span>
                                    <span v-else>STOP</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Date">
                              <template slot-scope="scope">
                                  {{ formatDate(scope.row.created_at) }}
                              </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isActiveActivityActive">
          <div class="filter row">
                <div class="col-md-12">
                    <div class="pull-left mar-rt-10">
                        <span class="pad-rg-5">{{$t('dispath.selectDriver')}}</span>
                        <v-select
                            multiple
                            style="display: inline-block; max-width: 600px;"
                            :options="drivers"
                            label="name"
                            v-model="selectedDriversActivity"
                        >
                        </v-select>
                    </div>
                    <div class="datetime-picker pull-left">
                        <!-- Selectați data și ora de început -->
                        <el-date-picker
                        v-model="fromDateTimeActivity"
                        type="datetime"
                        placeholder="Select From Date & Time"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                        to
                        <!-- Selectați data și ora de sfârșit -->
                        <el-date-picker
                        v-model="toDateTimeActivity"
                        type="datetime"
                        placeholder="Select To Date & Time"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                    </div>
                    <div class="pull-left search-button-reports">
                        <div
                            :title="$t('reports.search')"
                            class="btn btn-icon btn-info btn-search"
                            @click="sendActivityReport"
                        >
                            <i class="ti-search"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mar-to-15">
                <div class="card-content">
                    <div class="data-table">
                        <el-table :data="activityData" class="activityData">
                            <el-table-column :label="$t('dispath.driverID')">
                              <template slot-scope="scope">
                                  {{ scope.row.driver.id }}
                              </template>
                            </el-table-column>
                            <el-table-column :label="$t('dispath.driverName')">
                                <template slot-scope="scope">
                                    {{ scope.row.driver.firstname }} {{ scope.row.driver.lastname }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="total_minutes_active" :label="$t('dispath.totalActive')">
                              <template slot-scope="scope">
                                <div style="white-space: nowrap;">
                                  {{ scope.row.total_minutes_active }} mins
                                  <span style="margin: 0 10px;">|</span>
                                  {{ convertMinutesToHours(scope.row.total_minutes_active) }} hours
                                  <span style="margin: 0 10px;">|</span>
                                  {{ convertMinutesToDays(scope.row.total_minutes_active) }} days
                                </div>
                              </template>
                            </el-table-column>

                            <el-table-column prop="total_minutes_inactive" :label="$t('dispath.totalInactive')">
                              <template slot-scope="scope">
                                <div style="white-space: nowrap;">
                                  {{ scope.row.total_minutes_inactive }} mins
                                  <span style="margin: 0 10px;">|</span>
                                  {{ convertMinutesToHours(scope.row.total_minutes_inactive) }} hours
                                  <span style="margin: 0 10px;">|</span>
                                  {{ convertMinutesToDays(scope.row.total_minutes_inactive) }} days
                                </div>
                              </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isMapReportActive">
          <div class="filter row">
              <div class="col-md-12">
                  <div class="pull-left mar-rt-10">
                      <span class="pad-rg-5">{{$t('dispath.selectDriver')}}</span>
                      <select v-model="selectedDriversMap" class="form-control inline-auto white">
                        <option v-for="driver in drivers" :key="driver.id" :value="driver">
                          {{ driver.name }}
                        </option>
                      </select>
                  </div>
                  <div class="datetime-picker pull-left">
                      <!-- Selectați data și ora de început -->
                      <el-date-picker
                      v-model="fromDateTimeMap"
                      type="datetime"
                      placeholder="Select From Date & Time"
                      format="yyyy-MM-dd HH:mm"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :picker-options="pickerOptions"
                      >
                      </el-date-picker>
                      to
                      <!-- Selectați data și ora de sfârșit -->
                      <el-date-picker
                      v-model="toDateTimeMap"
                      type="datetime"
                      placeholder="Select To Date & Time"
                      format="yyyy-MM-dd HH:mm"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :picker-options="pickerOptions"
                      >
                      </el-date-picker>
                  </div>
                  <div class="pull-left search-button-reports">
                      <div
                          :title="$t('reports.search')"
                          class="btn btn-icon btn-info btn-search"
                          @click="sendMapReport"
                      >
                          <i class="ti-search"></i>
                      </div>
                  </div>
                  <div class="pull-right legend" @click="showLegend">
                    <div class="legends">
                      {{ $t('dispath.legend') }}
                    </div>
                  </div>
              </div>
          </div>
          <div class="mapsDispatch">
            <template>
              <div>
                <div class="card-map">
                  <div id="map" class="full-screen-map"></div>
                </div>
              </div>
            </template>
          </div>
        </div>
    </div>
</template>

  <script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import moment from 'moment'
  import swal from 'sweetalert2'
  import GoogleMapsLoader from 'google-maps'

  export default {
    components: {
      // GeneralTopBar
    },
    data () {
      return {
        loading: false,
        isWalletReportActive: false,
        isActiveProgramActive: false,
        isActiveActivityActive: false,
        isMapReportActive: true,
        drivers: [],
        selectedDriversWallet: [],
        selectedDriversProgram: [],
        selectedDriversActivity: [],
        selectedDriversMap: null,
        walletData: [],
        programData: [],
        activityData: [],
        fromDateTimeWallet: this.formatDate2(new Date(), 'start'),
        toDateTimeWallet: this.formatDate2(new Date(), 'end'),
        fromDateTimeProgram: this.formatDate2(new Date(), 'start'),
        fromDateTimeActivity: this.formatDate2(new Date(), 'start'),
        fromDateTimeMap: this.formatDate2(new Date(), 'start'),
        toDateTimeProgram: this.formatDate2(new Date(), 'end'),
        toDateTimeActivity: this.formatDate2(new Date(), 'end'),
        toDateTimeMap: this.formatDate2(new Date(), 'end'),
        pickerOptions: {
          disabledDate (time) {
            return false
          }
        },
        orderColors: [
          '#FF0000', '#00FF00', '#0000FF', '#FFFF00', '#FF00FF',
          '#00FFFF', '#800000', '#008000', '#000080', '#808000'
        ],
        map: null,
        points: [],
        markers: [],
        polylines: []
      }
    },
    mounted () {
      const locationsDetails = this.$session.get('selectedCompanyData').locations_details
      let apiKey = null

      for (let location of locationsDetails) {
        if (location.google_maps_api_key) {
          apiKey = location.google_maps_api_key
          break
        }
      }
      if (apiKey) {
        GoogleMapsLoader.KEY = apiKey
        GoogleMapsLoader.load((google) => {
          this.initMap(google)
        })
      } else {
        console.error('No Google Maps API key found in locations details.')
      }
    },
    created () {
      this.loadDriversFromSession()
    },
    methods: {
      openWalletReport () {
        this.isWalletReportActive = true
        this.isActiveProgramActive = false
        this.isActiveActivityActive = false
        this.isMapReportActive = false
      },
      openActiveProgram () {
        this.isActiveProgramActive = true
        this.isWalletReportActive = false
        this.isActiveActivityActive = false
        this.isMapReportActive = false
      },
      openActivityProgram () {
        this.isActiveProgramActive = false
        this.isWalletReportActive = false
        this.isActiveActivityActive = true
        this.isMapReportActive = false
      },
      openMapReport () {
        this.isActiveProgramActive = false
        this.isWalletReportActive = false
        this.isActiveActivityActive = false
        this.isMapReportActive = true
        this.$nextTick(() => {
          if (document.getElementById('map')) {
            this.initMap(window.google)
          } else {
            console.error('Containerul pentru hartă nu a fost găsit')
          }
        })
      },
      formatDate (dateString) {
        return new Date(dateString).toLocaleString()
      },
      formatDate2 (date, type) {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        if (type === 'start') {
          return `${year}-${month}-${day} 00:00:00`
        } else if (type === 'end') {
          return `${year}-${month}-${day} 23:59:59`
        }
        return `${year}-${month}-${day}`
      },
      convertMinutesToHours (minutes) {
        return (minutes / 60).toFixed(2) // Converts minutes to hours and rounds to 2 decimal places
      },
      convertMinutesToDays (minutes) {
        return (minutes / (60 * 24)).toFixed(2) // Converts minutes to days and rounds to 2 decimal places
      },
      loadDriversFromSession () {
        const driversFromSession = this.$session.get('drivers')
        if (driversFromSession) {
          this.drivers = driversFromSession
        } else {
          console.error('No drivers found in session')
        }
      },
      sendEncashmentReport () {
        if (!this.fromDateTimeWallet || !this.toDateTimeWallet) {
          alert('Please select from date and to date.')
          return
        }

        const driverIds = this.selectedDriversWallet.map(driver => driver.id)
        const fromDateFormatted = moment(this.fromDateTimeWallet).format('YYYY-MM-DD HH:mm:ss')
        const toDateFormatted = moment(this.toDateTimeWallet).format('YYYY-MM-DD HH:mm:ss')

        const dataToSend = {
          token: this.$session.get('token'),
          drivers_id: driverIds,
          from_date: fromDateFormatted,
          to_date: toDateFormatted
        }

        this.loading = true
        this.apiRequest('/encashment-raport', 'GET', dataToSend, (response) => {
          this.loading = false
          if (response.status === true) {
            this.walletData = response.data.driver_wallet.map(item => ({
              driverId: item.driver_id,
              driverName: item.driver.firstname ? `${item.driver.firstname} ${item.driver.lastname}` : 'N/A',
              adminName: item.admin ? `${item.admin.firstname} ${item.admin.lastname}` : 'N/A',
              orderId: item.order_id,
              value: item.value,
              createdAt: item.created_at
            }))
          } else {
            console.error('Failed to send encashment report:', response.message)
          }
        })
      },
      sendProgramReport () {
        if (!this.selectedDriversProgram.length || !this.fromDateTimeProgram || !this.toDateTimeProgram) {
          alert('Please select drivers, from date, and to date.')
          return
        }

        const driverIds = this.selectedDriversProgram.map(driver => driver.id)
        const fromDateFormatted = moment(this.fromDateTimeProgram).format('YYYY-MM-DD HH:mm:ss')
        const toDateFormatted = moment(this.toDateTimeProgram).format('YYYY-MM-DD HH:mm:ss')

        const dataToSend = {
          token: this.$session.get('token'),
          drivers_id: driverIds,
          from_date: fromDateFormatted,
          to_date: toDateFormatted
        }

        this.loading = true
        this.apiRequest('/program-raport', 'GET', dataToSend, (response) => {
          this.loading = false
          if (response.status === true) {
            this.programData = response.data.driver_wallet
          } else {
            console.error('Failed to send encashment report:', response.message)
          }
        })
      },
      sendActivityReport () {
        if (!this.selectedDriversActivity.length || !this.fromDateTimeActivity || !this.toDateTimeActivity) {
          alert('Please select drivers, from date, and to date.')
          return
        }

        const driverIds = this.selectedDriversActivity.map(driver => driver.id)
        const fromDateFormatted = moment(this.fromDateTimeActivity).format('YYYY-MM-DD HH:mm:ss')
        const toDateFormatted = moment(this.toDateTimeActivity).format('YYYY-MM-DD HH:mm:ss')

        const dataToSend = {
          token: this.$session.get('token'),
          drivers_id: driverIds,
          from_date: fromDateFormatted,
          to_date: toDateFormatted
        }

        this.loading = true
        this.apiRequest('/activity-raport', 'GET', dataToSend, (response) => {
          this.loading = false
          if (response.status === true) {
            this.activityData = response.data.drivers_activity
          } else {
            console.error('Failed to send encashment report:', response.message)
          }
        })
      },
      sendMapReport () {
        if (!this.selectedDriversMap || !this.fromDateTimeMap || !this.toDateTimeMap) {
          alert('Please select drivers, from date, and to date.')
          return
        }

        const driverId = this.selectedDriversMap ? this.selectedDriversMap.id : null
        const fromDateFormatted = moment(this.fromDateTimeMap).format('YYYY-MM-DD HH:mm:ss')
        const toDateFormatted = moment(this.toDateTimeMap).format('YYYY-MM-DD HH:mm:ss')

        const dataToSend = {
          token: this.$session.get('token'),
          driver_id: driverId,
          from_date: fromDateFormatted,
          to_date: toDateFormatted
        }

        this.loading = true
        this.apiRequest('/dispatch-map-raport', 'GET', dataToSend, (response) => {
          this.loading = false
          console.log('API response:', response)
          if (response.status === true) {
            this.addPointsToMap(response.data.points)
          } else {
            swal({
              type: 'error',
              title: 'Error',
              text: response.errors.time || 'Unknown error.',
              timer: 1500,
              showConfirmButton: false
            })
          }
        })
      },
      initMap (google) {
        // Setează locația inițială a mărcii
        var defaultLatlng = new window.google.maps.LatLng(44.4268, 26.1025)

        var mapStyles = [
          {
            featureType: 'all',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [{ color: '#d3d3d3' }]
          },
          {
            featureType: 'road',
            elementType: 'labels',
            stylers: [{ visibility: 'on' }]
          },
          {
            featureType: 'poi.business',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [{ color: '#c8e6c9' }]
          }
        ]

        // Setează opțiunile hărții
        var mapOptions = {
          zoom: 10,
          center: defaultLatlng,
          scrollwheel: false, // Dezactivează scroll-ul pe hartă
          styles: mapStyles
        }

        // Creează harta
        this.map = new window.google.maps.Map(document.getElementById('map'), mapOptions)
      },
      addPointsToMap (points) {
        if (!this.map) {
          console.error('Harta nu a fost inițializată.')
          return
        }

        // Verifică dacă `points` este definit și este un array
        if (!Array.isArray(points) || points.length === 0) {
          swal({
            type: 'error',
            title: 'Error',
            text: 'Points are not available or are not in a valid format.',
            timer: 1500,
            showConfirmButton: false
          })
          return
        }

        // Curăță markerii vechi
        this.markers.forEach(marker => marker.setMap(null))
        this.markers = []

        // Curăță linii vechi
        if (this.polylines) {
          this.polylines.forEach(polyline => polyline.setMap(null))
        }
        this.polylines = []

        // Creează un obiect LatLngBounds pentru a include toate punctele
        const bounds = new window.google.maps.LatLngBounds()

        // Creează un InfoWindow pentru a afișa informațiile
        const infoWindow = new window.google.maps.InfoWindow()

        // Array pentru stocarea coordonatelor pentru polilinie
        const path = []

        // Adaugă markerii pe hartă și actualizează limitele
        points.forEach((point, index) => {
          // const colorIndex = point.order_id ? point.order_id % this.orderColors.length : 0
          // const color = this.orderColors[colorIndex]

          let color = '#FF0000' // Roșu dacă nu are order_id

          if (point.order_id) {
            color = '#17B086' // Verde dacă are order_id
          } else {
            color = '#800080' // Mov dacă nu are order_id
          }

          const marker = new window.google.maps.Marker({
            position: new window.google.maps.LatLng(point.gps_latitude, point.gps_longitude),
            map: this.map,
            icon: {
              path: window.google.maps.SymbolPath.CIRCLE,
              scale: 7,
              fillColor: color,
              fillOpacity: 0.8,
              strokeWeight: 0
            }
          })

          // Extinde limitele pentru a include acest marker
          bounds.extend(marker.getPosition())

          // Adaugă coordonata la array-ul pentru polilinie
          path.push(marker.getPosition())

          // Adaugă un event listener pentru clic pe marker
          marker.addListener('click', () => {
            // Construiește conținutul pentru InfoWindow
            const content = `
              <div>
                <strong>Order ID:</strong> ${point.order_id ? point.order_id : 'N/A'}<br>
                <strong>Created At:</strong> ${point.created_at ? point.created_at : 'N/A'}
              </div>
            `
            infoWindow.setContent(content)
            infoWindow.open(this.map, marker)
          })

          // Salvează referința markerului
          this.markers.push(marker)
        })

        // Creează și adaugă poliliniile pe hartă în funcție de culoarea segmentului
        let segmentPath = []
        points.forEach((point, index) => {
          let color = '#FF0000' // Roșu implicit
          if (point.order_id) {
            color = '#00FF00' // Verde dacă are order_id
          } else {
            color = '#800080' // Mov dacă nu are order_id
          }

          segmentPath.push(new window.google.maps.LatLng(point.gps_latitude, point.gps_longitude))

          // Verifică dacă trebuie să schimbăm culoarea pentru a crea un nou segment de linie
          if (index < points.length - 1) {
            const nextPoint = points[index + 1]
            const nextColor = nextPoint.order_id ? '#00FF00' : '#800080'

            if (color !== nextColor) {
              // Creează polilinia pentru segmentul curent
              if (segmentPath.length > 1) {
                const polyline = new window.google.maps.Polyline({
                  path: segmentPath,
                  geodesic: true,
                  strokeColor: color, // Culoarea liniei pentru segmentul curent
                  strokeOpacity: 1.0,
                  strokeWeight: 2,
                  icons: [
                    {
                      icon: {
                        path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW, // Săgeata
                        scale: 1.5, // Dimensiunea săgeții
                        strokeColor: color, // Culoarea săgeții
                        strokeWeight: 1
                      },
                      repeat: '20px' // Plasează săgeți la fiecare 20px pe linie
                    }
                  ]
                })

                polyline.setMap(this.map)
                this.polylines.push(polyline)
              }

              // Începe un nou segment
              segmentPath = [new window.google.maps.LatLng(point.gps_latitude, point.gps_longitude)]
            }
          }
        })

        // Creează și adaugă polilinia pentru ultimul segment
        if (segmentPath.length > 1) {
          const lastColor = points[points.length - 1].order_id ? '#00FF00' : '#800080'
          const polyline = new window.google.maps.Polyline({
            path: segmentPath,
            geodesic: true,
            strokeColor: lastColor,
            strokeOpacity: 1.0,
            strokeWeight: 2,
            icons: [
              {
                icon: {
                  path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                  scale: 1.5,
                  strokeColor: lastColor,
                  strokeWeight: 1
                },
                repeat: '20px'
              }
            ]
          })

          polyline.setMap(this.map)
          this.polylines.push(polyline)
        }

        // Ajustează harta pentru a include toate markerii
        this.map.fitBounds(bounds)
      },
      showLegend () {
        swal({
          title: this.$t('dispath.legend'),
          html: `
            <div style="text-align: left; padding: 0 20px;">
              <!-- Legend for Stop with Delivery -->
              <div style="display: flex; align-items: center; margin-top: 30px; margin-bottom: 10px;">
                <p style="margin: 0; font-weight: 500; margin-right: 20px; width: 166px;">
                  ${this.$t('dispath.stopWithDelivery')}:
                </p>
                <span style="display: inline-block; width: 20px; height: 20px; border-radius: 50%; background-color: #3DBE9C;"></span>
              </div>

              <!-- Legend for Driver with Delivery -->
              <div style="display: flex; align-items: center; margin-bottom: 10px;">
                <p style="margin: 0; font-weight: 500; margin-right: 20px; width: 162px;">
                  ${this.$t('dispath.driverWithOrder')}:
                </p>
                <svg width="220" height="40" style="display: block;">
                  <!-- Line -->
                  <line x1="20" y1="20" x2="200" y2="20" stroke="#00FF00" stroke-width="4" />
                  <!-- Right Arrow -->
                  <polygon points="200,15 200,25 210,20" fill="#00FF00" />
                  <!-- Left Arrow -->
                  <polygon points="20,15 20,25 10,20" fill="#00FF00" />
                  <!-- Label -->
                  <text x="110" y="38" fill="#000000" font-size="12" text-anchor="middle">${this.$t('dispath.movementDirection')}</text>
                </svg>
              </div>

              <!-- Legend for Stop without Delivery -->
              <div style="display: flex; align-items: center; margin-bottom: 10px;">
                <p style="margin: 0; font-weight: 500; margin-right: 20px; width: 166px;">
                  ${this.$t('dispath.stopWithoutDelivery')}:
                </p>
                <span style="display: inline-block; width: 20px; height: 20px; border-radius: 50%; background-color: #800080;"></span>
              </div>

              <!-- Legend for Driver without Delivery -->
              <div style="display: flex; align-items: center;">
                <p style="margin: 0; font-weight: 500; margin-right: 20px;">
                  ${this.$t('dispath.driverWithoutOrder')}:
                </p>
                <svg width="220" height="40" style="display: block;">
                  <!-- Line -->
                  <line x1="20" y1="20" x2="200" y2="20" stroke="#800080" stroke-width="4" />
                  <!-- Right Arrow -->
                  <polygon points="200,15 200,25 210,20" fill="#800080" />
                  <!-- Left Arrow -->
                  <polygon points="20,15 20,25 10,20" fill="#800080" />
                  <!-- Label -->
                  <text x="110" y="38" fill="#000000" font-size="12" text-anchor="middle">${this.$t('dispath.movementDirection')}</text>
                </svg>
              </div>
            </div>
          `,
          confirmButtonText: this.$t('general.close')
        })
      }
    }
  }
  </script>

  <style>
  .el-date-editor .el-range-separator {
    padding: 0 2px;
  }
  #outer-container .navButtons .card-content {
    padding-left: 0px;
  }
  .el-table .cell {
    height: 55px;
  }
  .pull-right.legend {
    margin-top: 15px;
    cursor: pointer;
    text-decoration: underline;
  }
  .card-map .full-screen-map {
    height: 660px;
  }
  </style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dispatch/DispatchReports.vue